import {
  blue500,
  yellow500,
  liCriticalAccent,
  liCriticalText,
  liCriticalBorder,
  liCriticalBg,
  liModerateAccent,
  liModerateText,
  liModerateIcon,
  liModerateBorder,
  liModerateBg,
  liMinorAccent,
  liMinorText,
  liMinorBorder,
  liMinorBg,
  liStableAccent,
  liStableText,
  liStableBorder,
  liStableBg,
  liMissingData,
  liAging,
  liBorderDefault,
  liTextTertiary,
} from './base-variables';

// Status & Alert colors from Lithium Library 2.0; names follow the Figma tokens.
export interface SeverityColors {
  readonly accent: string;
  readonly text: string;
  readonly border: string;
  readonly background: string;
}

export interface ModerateSeverityColorSet extends SeverityColors {
  readonly icon: string;
}

export const CriticalSeverityColors: SeverityColors = {
  accent: liCriticalAccent,
  text: liCriticalText,
  border: liCriticalBorder,
  background: liCriticalBg,
};

export const ModerateSeverityColors: ModerateSeverityColorSet = {
  accent: liModerateAccent,
  text: liModerateText,
  icon: liModerateIcon,
  border: liModerateBorder,
  background: liModerateBg,
};

export const MinorSeverityColors: SeverityColors = {
  accent: liMinorAccent,
  text: liMinorText,
  border: liMinorBorder,
  background: liMinorBg,
};

export const StableSeverityColors: SeverityColors = {
  accent: liStableAccent,
  text: liStableText,
  border: liStableBorder,
  background: liStableBg,
};

export const MISSING_DATA_COLOR = liMissingData;
export const AGING_COLOR = liAging;
export const DEFAULT_BORDER_COLOR = liBorderDefault;

export const IconColors = {
  lightGray: liTextTertiary,
} as const;

export const StandardStatusColors = {
  green: StableSeverityColors.accent,
  blue: blue500,
  yellow: yellow500,
} as const;

export const RecoverableEnergyColors = {
  available: StandardStatusColors.green,
  recoverable: StandardStatusColors.blue,
  aging: AGING_COLOR,
} as const;
